import { StatusCard, Button, Flex, Icon, Text } from "src/components";
import { useTranslation } from "react-i18next";
import { TRANSLATION } from "src/models/constants";
import styling from "./NotFoundPage.module.scss";

export const NotFoundPage = () => {
	const { t } = useTranslation([TRANSLATION.COMMON]);

	return (
		<Flex.Row width="100vw" height="100vh" alignment="center" className={styling["wrapper"]}>
			<Flex.Column alignment="center" className={styling["image"]}>
				<StatusCard
					color="warning"
					icon={<Icon name="LargeWarning" />}
					title={t("COMMON:notFound.title")}
					description={t("COMMON:notFound.message")}
					className={styling["card"]}
					childrenWithin={
						<Flex.Column alignment="top-left" gap="large" width="100%">
							<Text.Body.Medium weight="semi-bold" color="secondary">
								{t("COMMON:notFound.navDescription")}
							</Text.Body.Medium>
							<Flex.Row render={<nav />} alignment="center-left" justifyContent="space-between" width="100%" gap={"large"}>
								<Flex.Row alignment="center-left" gap={"large"} width="auto" render={<nav />}>
									<Button color={"neutral"} variant={"soft"}>
										{t("COMMON:notFound.emailText")}
									</Button>
									<Button color={"neutral"} variant={"soft"}>
										{t("COMMON:notFound.numberText")}
									</Button>
								</Flex.Row >
								<Button
									rightIcon={<Icon name="LargeHistoricalBrowser" />}
									variant={"solid"}
									onClick={() => {
										window.location.reload();
									}}
								>
									{t("COMMON:notFound.refreshText")}
								</Button>
							</Flex.Row>
						</Flex.Column>
					}
				/>
			</Flex.Column>
		</Flex.Row>
	);
};
